// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import WorkAnnouncementsController from "./work_announcements_controller.js"
import WorkTensesController from "./work_tenses_controller.js"
import OrgFlowyListController from "./org_flowy_list_controller.js"

application.register("work-announcements", WorkAnnouncementsController)
application.register("work-tenses", WorkTensesController)
application.register("org-flowy-list", OrgFlowyListController)

// TODO https://github.com/hotwired/stimulus/issues/328#issuecomment-722040944
window.addEventListener('pageshow', event => {
  application.controllers.forEach(controller => {
    if (typeof controller.pageShow === 'function') {
      controller.pageShow(event.persisted)
    }
  })
})
